<template>
    <div>
        <div class="container">
            <div class="field">
                <label class="label" for="payload">{{ CONSTANTS.getCopy('BUTTONS_PAYLOAD') }}</label>
                <input :class="{'input-error': !payload && showError}" type="text" id="payload" v-model="payload"/>
            </div>
            <div class="field">
                <label class="label" for="text">{{ CONSTANTS.getCopy('BUTTONS_TEXT') }}</label>
                <input :class="{'input-error': !text && showError}" type="text" id="text" v-model="text"/>
            </div>
            <div class="field">
                <label class="label" for="keywords">{{ CONSTANTS.getCopy('BUTTON_KEYWORDS') }}</label>
                <input type="text" id="keywords" v-model="keywords"/>
            </div>
            <div class="button is-primary is-left" @click="addButton">
                <span>{{ CONSTANTS.getCopy('BUTTON_ADD_BUTTON') }}</span>
            </div>
        </div>
        <br>
    </div>
</template>

<script>
export default {
  data () {
    return {
      payload: null,
      text: null,
      keywords: null,
      showError: false,
      syntax: null
    }
  },
  methods: {
    addButton () {
      if (!this.payload || !this.text) {
        this.showError = true
        return
      }
      if (this.keywords) {
        this.syntax = `[BUTTON_${this.payload}_${this.text}_${this.keywords}]`
        this.cleanAndClose()
        this.$emit('button-syntax', this.syntax)
        return
      }
      this.syntax = `[BUTTON_${this.payload}_${this.text}]`
      this.cleanAndClose()
      this.$emit('button-syntax', this.syntax)
    },
    cleanAndClose () {
      this.payload = null
      this.text = null
      this.keywords = null
      this.showError = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/templates/Buttons.vue